import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import { environment } from '../../environments/environment';
import "rxjs/add/operator/toPromise";

import { Athlete } from "../_models/athlete.model";
import { Parent } from "../_models/parent.model";

import * as moment from 'moment'

@Injectable()
export class ParentService {
    constructor(private http: Http) { }

    listAthletes(parent_account_id = "") {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log(currentUser);
        if (currentUser && currentUser.access_token) {
            console.log("has token");
            headers.append("access_token", currentUser.access_token);
        }

        var id = currentUser.userdata.parent_account_id;
        if (parent_account_id) {
            id = parent_account_id;
        }


        return this.http.get(environment.apiUrl + "parent/" + id, {
            headers: headers
        })
            .toPromise()
            .then((res: Response) => {
                let data = res.json();
                let allAthletes = [];

                data.data.forEach((entry) => {
                    let athlete = new Athlete();

                    athlete.id = entry.athlete_id;
                    athlete.first_name = entry.first_name;
                    athlete.last_name = entry.last_name;
                    athlete.phone = entry.phone;
                    athlete.email = entry.email;
                    athlete.compliant = entry.compliant;
                    athlete.document_path = entry.document_path;
                    athlete.sportgait_id = entry.sportgait_id;
                    athlete.has_baseline = entry.has_baseline;

                    athlete.dob = moment.utc(entry.dob).format("MM/DD/YY");
                    athlete.created_on = moment(entry.created_on).format("MM/DD/YY");

                    athlete.workflow_tasks = entry.workflow_tasks;

                    var non_compliant_count = 2 - (entry.compliance_count / 2);

                    athlete.non_compliant_count = non_compliant_count;

                    var total_complete = 0;

                    athlete.club_name = entry.club[0].club_name;

                    var due_date = "07/13/2018";
                    athlete.show_schedule_baseline_alert = false;

                    athlete.gender = "";

                    if (entry.gender == "m") {
                        athlete.gender = "Male";
                    }

                    if (entry.gender == "f") {
                        athlete.gender = "Female";
                    }



                    if (entry.club[0] && entry.club[0].club_id) {
                        if (entry.club[0].club_id == 2 && !entry.has_baseline && entry.athlete_id < 843) { //hotspurs fall
                            athlete.show_schedule_baseline_alert = true;
                            due_date = "08/23/2018";
                        }
                    }


                    var i;
                    for (i = 0; i < athlete.workflow_tasks.length; i++) {

                        athlete.workflow_tasks[i].due_date = due_date;

                        athlete.workflow_tasks[i].is_complete = false;
                        if (athlete.workflow_tasks[i].parent_auth_complete && athlete.workflow_tasks[i].athlete_auth_complete) {
                            athlete.workflow_tasks[i].is_complete = true;
                            total_complete++;
                        }

                        athlete.workflow_tasks[i].pdf_link_parent_auth = environment.apiUrl + "athlete/" + entry.athlete_id + "/workflow_task/" + athlete.workflow_tasks[i].workflow_task_id + "/parent_auth";
                        athlete.workflow_tasks[i].pdf_link_athlete_auth = environment.apiUrl + "athlete/" + entry.athlete_id + "/workflow_task/" + athlete.workflow_tasks[i].workflow_task_id + "/athlete_auth";
                        athlete.workflow_tasks[i].pdf_link = environment.apiUrl + "athlete/" + entry.athlete_id + "/workflow_task/" + athlete.workflow_tasks[i].workflow_task_id;

                        athlete.workflow_tasks[i].last_modified_on = moment(athlete.workflow_tasks[i].last_modified_on).format("MM/DD/YY hh:mm a");

                    }

                    athlete.workflow_tasks.sort(function(a, b) {
                        return b.workflow_task_id - a.workflow_task_id;
                    });

                    athlete.is_compliant = false;
                    if (total_complete >= 2) {
                        athlete.is_compliant = true;
                    }

                    athlete.compliant_status = false;

                    if (entry.compliant == "compliant") {
                        athlete.compliant_status = true;
                    }

                    athlete.removed = false;

                    if (entry.is_removed) {
                        athlete.removed = true;
                        athlete.is_removed = true;
                    }

                    athlete.removed = false;

                    if (entry.is_removed_pending) {
                        athlete.is_removed_pending = true;
                    }

                    if (entry.athlete_id) {
                        allAthletes.push(athlete);
                    }

                });

                let parent = new Parent();
                parent.athletes = allAthletes;

                return parent;
            })
            .catch(this.handleError);
    }


    get(id: number) {
        function checkRole() {
            // create authorization header with jwt token
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            console.log(currentUser);
            //@TODO: ?
            if (currentUser && currentUser.userdata.email == "kzeiger@lifegait.com") {
                return "associationadmin";
            } else {
                return "associationadmin";
            }
        }


        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log(currentUser);
        if (currentUser && currentUser.access_token) {
            console.log("has token");
            headers.append("access_token", currentUser.access_token);
        }

        return this.http.get(environment.apiUrl + "athlete/" + id, {
            headers: headers
        })
            .toPromise()
            .then((res: Response) => {
                let data = res.json();
                let athlete = new Athlete();
                athlete.first_name = data.data.first_name;
                athlete.last_name = data.data.last_name;
                athlete.id = data.data.RecordID;
                athlete.phone = data.data.phone;
                athlete.email = data.data.email;
                athlete.compliant = data.data.compliant;

                console.log(data.data.workflow_tasks);
                athlete.workflow_tasks = data.data.workflow_tasks;




                athlete.compliant_status = false;

                if (data.data.compliant == "compliant") {
                    athlete.compliant_status = true;
                }

                athlete.removed = false;

                if (data.data.removed_status == "removed") {
                    athlete.removed = true;
                }

                /*
                    data.types.forEach((eachType) => {
                      staff.types.push(eachType.type.name);
                    });
                
                    data.stats.forEach((eachStat) => {
                      staff.stats.push({
                        name: eachStat.stat.name,
                        value: eachStat.base_stat
                      });
                    });
                    */

                return athlete;
            })
            .catch(this.handleError);
    }



    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || "";
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Promise.reject(errMsg);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/parent-service.ts